import React, { useState, ReactNode } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Helmet } from "react-helmet";
import theme from "./theme";
import { ThemeProvider, makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Container, IconButton } from "@material-ui/core";
import { SnackbarAlert, Loading } from "~/components";
import { RootState } from "~/redux/rootReducer";
import { Header } from "./components/header";
import MenuIcon from "@material-ui/icons/Menu";
import { Sidebar } from "./components/sidebar";
import { resetAlert } from "~/redux/modules/admin/screen";

type Props = {
  children: ReactNode;
  loading?: boolean;
};

export const Layout: React.VFC<Props> = (props) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const drawerWidth = 220;

  // global state
  const adminAuth = useSelector((state: RootState) => state.adminAuth);
  const adminScreen = useSelector((state: RootState) => state.adminScreen);

  // アラートを閉じる
  const onCloseAlert = () => dispatch(resetAlert());

  // サイドバー 開閉
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);

  if (adminAuth.isInit) {
    return (
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>SHUZO 運営会社向けサイト</title>
        </Helmet>

        {/* ヘッダー */}
        <Header
          drawerButton={
            adminAuth.login &&
            isMobile && (
              <IconButton
                color="inherit"
                onClick={handleDrawerOpen}
                edge="start"
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>
            )
          }
        />

        <div className={classes.main}>
          {/* サイドバー */}
          {adminAuth.login && (
            <Sidebar
              open={open}
              onClose={handleDrawerClose}
              width={drawerWidth}
            />
          )}

          {/* コンテンツ */}
          <Container className={classes.container} maxWidth="md">
            <div>{props.children}</div>
          </Container>
        </div>

        {/* アラート表示 */}
        <SnackbarAlert
          open={adminScreen.showAlert}
          onClose={onCloseAlert}
          message={adminScreen.alert?.message}
          type={adminScreen.alert?.type}
        />

        {/* ローディング */}
        <Loading
          open={
            adminAuth.loading || adminScreen.loading || props.loading === true
          }
        />
      </ThemeProvider>
    );
  } else {
    return <Loading open />;
  }
};

const useStyles = makeStyles({
  main: {
    display: "flex",
  },
  container: {
    textAlign: "center",
    paddingTop: 64,
    flexGrow: 1,
  },
  menuButton: {
    marginRight: 10,
  },
});
